import { NotificationActions, NotificationsTypes } from './notification.store';
import { success } from '../resources/messages';

export const AuthStoreDefinition = {
  state: {
    isAuthenticated: false,
    isPending: false,
    user: null,
    hasError: false,
  },
  mutations: {
    authCleanError(state) {
      state.hasError = false;
    },
    authAddError(state) {
      state.hasError = true;
    },
    loggedIn(state, payload) {
      state.isAuthenticated = true;
      state.user = payload;
    },
    loggedOut(state) {
      state.isAuthenticated = false;
      state.user = null;
    },
    authStartQuery(state) {
      state.isPending = true;
    },
    authEndQuery(state) {
      state.isPending = false;
    }
  },
  actions: {
    startLogin({ commit }) {
      commit(AuthMutations.authCleanError);
      commit(AuthMutations.authStartQuery);
    },
    endLoginSuccess({ commit, dispatch }, payload) {
      commit(AuthMutations.loggedIn, payload);
      commit(AuthMutations.authEndQuery);
      dispatch(NotificationActions.createNotification, { type: NotificationsTypes.success, message: success.auth.signin });
    },
    endLoginSuccessSilently({ commit }, payload) {
      commit(AuthMutations.loggedIn, payload);
      commit(AuthMutations.authEndQuery);
    },
    endLoginError({ commit }) {
      commit(AuthMutations.loggedOut);
      commit(AuthMutations.authAddError);
      commit(AuthMutations.authEndQuery);
    },
    startLogout({ commit }) {
      commit(AuthMutations.authCleanError);
      commit(AuthMutations.authStartQuery);
    },
    endLogoutSuccess({ commit, dispatch }) {
      commit(AuthMutations.loggedOut);
      commit(AuthMutations.authEndQuery);
      dispatch(NotificationActions.createNotification, { type: NotificationsTypes.success, message: success.auth.signout });
    },
    endLogoutError({ commit }) {
      commit(AuthMutations.loggedOut);
      commit(AuthMutations.authAddError);
      commit(AuthMutations.authEndQuery);
    }
  }
};

export const AuthMutations = {
  authCleanError: 'authCleanError',
  authAddError: 'authAddError',
  loggedIn: 'loggedIn',
  loggedOut: 'loggedOut',
  authStartQuery: 'authStartQuery',
  authEndQuery: 'authEndQuery',
};

export const AuthActions = {
  startLogin: 'startLogin',
  endLoginSuccess: 'endLoginSuccess',
  endLoginSuccessSilently: 'endLoginSuccessSilently',
  endLoginError: 'endLoginError',
  startLogout: 'startLogout',
  endLogoutSuccess: 'endLogoutSuccess',
  endLogoutError: 'endLogoutError',
};
